module.exports = {"height":15,"min":0,"max":5,"tooltip":"false","class":"mx-4 mx-sm-0","speed":0.5,"bgStyle":{"margin":"0 auto","background":"#fff","boxShadow":"inset .5px .5px 3px 1px rgba(0,0,0,.3)"},"sliderStyle":{"backgroundColor":"#AAAAAA"},"dotHeight":25,"processStyle":{},"piecewise":true,"piecewiseStyle":{"backgroundColor":"#616161","width":"1px","height":"10px"},"color":["#1B5E20","#1B5E20","#CDDC39","#FFEB3B","#F9A825","#E64A19"]}


//////////////////
// WEBPACK FOOTER
// ./src/components/question/options-slider.json
// module id = 888
// module chunks = 0